<!-- Show the skeleton loader when loading is true, otherwise show the regular content -->
<ng-container *ngIf="loading">
  <app-calendar-skeleton-loader></app-calendar-skeleton-loader>
</ng-container>

<!-- Show the calendar content when not loading -->
<ng-container *ngIf="!loading">
  <ng-container *ngIf="!showCalendarMode(); else matCardTemplate">
    <div class="navigation-container">
      <button
        mat-icon-button
        mwlCalendarPreviousView
        [view]="defaultView()"
        [(viewDate)]="viewDate"
        (click)="changeView()"
      >
        <mat-icon>chevron_left</mat-icon>
      </button>
      <span class="navigation-title">
        {{ viewDate | calendarDate : defaultView() + "ViewTitle" : "en" }}
      </span>
      <button
        mat-icon-button
        mwlCalendarNextView
        [view]="defaultView()"
        [(viewDate)]="viewDate"
        (click)="changeView()"
      >
        <mat-icon>chevron_right</mat-icon>
      </button>
    </div>
    
    <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
  </ng-container>

  <ng-template #matCardTemplate>
    <mat-card class="cardWithShadow overflow-hidden">
      <mat-toolbar class="no-shadow">
        <mat-toolbar-row>
          <!-- Left side: Meeting duration (when scheduler is active) or Calendar title -->
          <div class="d-flex align-items-center w-100">
            @if(meetingScheduler()){
              <div class="meeting-duration">
                <span>Meeting duration</span>
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                  <mat-select [(ngModel)]="meetingDuration" (selectionChange)="onMeetingDurationChange($event)">
                    <mat-option value="15">15 min</mat-option>
                    <mat-option value="30">30 min</mat-option>
                    <mat-option value="60">1 hour</mat-option>
                    <mat-option value="90">1.5 hours</mat-option>
                    <mat-option value="120">2 hours</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            }
            @if(!meetingScheduler()){
              <span class="calendar-title">{{ viewDate | calendarDate : defaultView() + "ViewTitle" : "en" }}</span>
            }
            
            <!-- Right side: Filters and navigation buttons -->
            <div class="m-l-auto d-flex align-items-center">
              <!-- Filters -->
              <div class="toolbar-filters">
                <app-filters
                  [types]="activityTypes"
                  [hideTimeLineFilter]="true"
                  [defaultSelectedTypeIds]="defaultSelectedTypeIds()"
                  [useMultiselect]="true"
                  (typeSelected)="onTypeSelected($event)">
                </app-filters>
              </div>
              
              <!-- View controls and navigation buttons -->
              <button
                mat-icon-button
                (click)="clickView('week')"
                [class.active]="defaultView() === 'week'"
                matTooltip="Week view"
              >
                <mat-icon>view_week</mat-icon>
              </button>
              <button
                mat-icon-button
                (click)="clickView('day')"
                [class.active]="defaultView() === 'day'"
                matTooltip="Day view"
              >
                <mat-icon>view_day</mat-icon>
              </button>
              <button
                mat-icon-button
                mwlCalendarPreviousView
                [view]="defaultView()"
                [(viewDate)]="viewDate"
                (click)="changeView()"
                matTooltip="Previous"
              >
                <mat-icon>chevron_left</mat-icon>
              </button>
              <button 
              mat-icon-button 
              mwlCalendarToday 
              [(viewDate)]="viewDate"
              (click)="changeView()"
              matTooltip="Today"
            >
              <mat-icon>today</mat-icon>
            </button>
              <button
                mat-icon-button
                mwlCalendarNextView
                [view]="defaultView()"
                [(viewDate)]="viewDate"
                (click)="changeView()"
                matTooltip="Next"
              >
                <mat-icon>chevron_right</mat-icon>
              </button>
            </div>
          </div>
        </mat-toolbar-row>
      </mat-toolbar>
      <mat-card-content>
        <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
      </mat-card-content>
    </mat-card>
  </ng-template>
</ng-container>

<ng-template #contentTemplate>
  <ng-template #customEventTemplate let-event="event">
            
      <div *ngIf="event" class="custom-event" 
      
           [style.backgroundColor]="event.color?.secondary || 'defaultColor'"
           [style.borderColor]="event.color?.primary || 'defaultBorderColor'">
           <!-- <mat-icon class="top-right-icon">circle</mat-icon> -->
           @if(event.meta?.meetingScheduler){
            <button class="delete-button" mat-icon-button (click)="removeEvent(event)">
              <mat-icon class="delete-icon">delete</mat-icon>
            </button>
           }
           
           <div  class="cal-event-title" [ngClass]="{ 'completed-title': event.completed }">
             @if(!event.meta?.meetingScheduler){
              <mat-icon class="event-icon">{{event?.type?.icon}}</mat-icon>
              
              <span class="event-title">{{ event.title || 'Untitled Event' }}</span>
             }
             
            </div>
            
        <div class="cal-event-title" *ngIf="event.start">
          {{ event.start | date:'shortTime' }} 
          <span *ngIf="event.end"> - {{ event.end | date:'shortTime' }}</span>
          
        </div>
      </div>
    </ng-template>

    <ng-template
    #weekViewHourSegmentTemplate
    let-segment="segment"
    let-locale="locale"
    let-segmentHeight="segmentHeight"
    let-isTimeLabel="isTimeLabel"
  >
    <div
      #segmentElement
      class="cal-hour-segment"
      [style.height.px]="segmentHeight"
      [class.cal-hour-start]="segment.isStart"
      [class.cal-after-hour-start]="!segment.isStart"
      [ngClass]="segment.cssClass"
      (mousedown)="startDragToCreate(segment, $event, segmentElement)"
      
    >
      <div class="cal-time" *ngIf="isTimeLabel">
        {{ segment.date | calendarDate: 'dayViewHour': locale }}
        
      </div>
    </div>
  </ng-template>
    <div class="scroll-container" #scrollContainer>
      @if(defaultView() === 'month'){
          <mwl-calendar-month-view
          [viewDate]="viewDate"
          [events]="events"
          [activeDayIsOpen]="activeDayIsOpen"
          (dayClicked)="dayClicked($event.day)"
          (eventClicked)="handleEvent('Clicked', $event.event)"
          (eventTimesChanged)="eventTimesChanged($event)"
        >
        </mwl-calendar-month-view>
        } @else if (defaultView() === 'week'){
          <div class="calendar-container">
            <mwl-calendar-week-view
            [viewDate]="viewDate"
            [events]="events"
            (eventClicked)="handleEvent('view', $event.event, $event.sourceEvent)"
            (eventTimesChanged)="eventTimesChanged($event)"
            [hourSegments]="hourSegments()"
            [hourSegmentTemplate]="weekViewHourSegmentTemplate"
            [weekStartsOn]="weekStartsOn"
            [dayStartHour]="dayStartHour()"
            [dayEndHour]="dayEndHour()"
            (hourSegmentClicked)="hourSegmentClicked($event.date)"
            [hourSegmentHeight]="hourSegments() == 2 ? 30 : 20"
            [eventTitleTemplate]="customEventTemplate"
          >
          </mwl-calendar-week-view>
          </div>
          
        }
        @else{
         
        
          <mwl-calendar-day-view
          [viewDate]="viewDate"
          [events]="events"
          (eventClicked)="handleEvent('view', $event.event)"
          (eventTimesChanged)="eventTimesChanged($event)"
          [hourSegments]="hourSegments()"
          [hourSegmentTemplate]="weekViewHourSegmentTemplate"
          [eventTitleTemplate]="customEventTemplate"
          [dayStartHour]="dayStartHour()"
          [dayEndHour]="dayEndHour()"
          (hourSegmentClicked)="hourSegmentClicked($event.date)"
          [hourSegmentHeight]="hourSegments() == 2 ? 30 : 20"
          
          
        >
        </mwl-calendar-day-view>
        }

    </div>
</ng-template>